interface Access<T> {
  [key: string]: T
}

export const Accessibilities: Access<string> = {
  "Assisted Listening": env.themePath + "assets/icons/access/Access-Assisted-Listening.svg",
  "Assistive Animals": env.themePath + "assets/icons/access/Access-Assistive-Animals.svg",
  "Audio Description": env.themePath + "assets/icons/access/Access-Audio-Description.svg",
  "Auslan Interpreted": env.themePath + "assets/icons/access/Access-Auslan-Interpreted.svg",
  "Close Captioned": env.themePath + "assets/icons/access/Access-Close-Captioned.svg",
  "Open Captioned": env.themePath + "assets/icons/access/Access-Open-Captioned.svg",
  "Relaxed Event": env.themePath + "assets/icons/access/Access-Relaxed-Event.svg",
  Subtitled: env.themePath + "assets/icons/access/Access-Subtitled.svg",
  Wheelchair: env.themePath + "assets/icons/access/Access-Wheelchair.svg",
}
